<template >
  <div>
    <v-overlay :value="overlay || $store.state.loading_pdf">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div>
      <div class="formPosition">
        <v-card style="margin:auto;" width="1240">
          <v-card-title style="background-color:#006699;color:white;"></v-card-title>
          <v-progress-linear style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
          <v-data-table :headers="headers" :items="dados" :search="searchInDb" sort-by="data_" class="elevation-3">
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-row>
                  <v-col md="11">
                    <v-toolbar-title>Emolumentos Por Classe</v-toolbar-title>
                  </v-col>
                </v-row>
                <v-row>
                 <v-col md="4">
                    <v-select v-model="editedItem.emolumento" :rules="ruleRequired" item-value="id" item-text="descricao" :items="emolumentos"  label="Selecione o emolumento" return-object></v-select>
                  </v-col>
                  <v-col md="4">
                    <v-select :disabled="editedItem.emolumento === '' || editedItem.emolumento === null" v-model="editedItem.classe" :rules="ruleRequired" item-value="id" item-text="descricao" :items="classes"  label="Selecione a classe" return-object></v-select>
                  </v-col>
                  
                  <v-col md="1">
                    <v-btn small fab color="green" :disabled="(editedItem.emolumento === '' || editedItem.emolumento === null || editedItem.classe === '' || editedItem.classe === null)" @click="getVendas()" style="color:white;"><v-icon>search</v-icon></v-btn>
                  </v-col>
                  <v-col md="1" v-if="dados.length">
                    <v-btn small fab color="primary" @click="gerarHTML()"><v-icon>print</v-icon></v-btn>
                  </v-col>
                </v-row>
              </v-toolbar>
              <div style="text-align: center;">
                <v-progress-circular :size="50" color="primary" indeterminate v-if="isLodingPDF"></v-progress-circular>
              </div>
            </template>
            <template v-slot:item.ordem="{ item }">
              <span>{{ dados.indexOf(item) + 1 }}</span>
            </template>
            <template v-slot:item.precoUnitario="{ item }">
              <span>{{ util.IntegerToMoneyValueFatura(item.precoUnitario) }}</span>
            </template>
            <template v-slot:item.subtotal="{ item }">
              <span>{{ util.IntegerToMoneyValueFatura(item.subtotal) }}</span>
            </template>
            <template v-slot:no-data> Clica em + para adicionar novo estudante </template>
          </v-data-table>
          <v-card-actions>
            <v-row>
              <v-col md="6"></v-col>
              <v-col md="3"><span style="font-weight:bold;">Total de Multas:</span><v-chip>0,00 Kz</v-chip></v-col>
              <v-col md="3"><span style="font-weight:bold;">Total Geral:</span><v-chip>{{ util.IntegerToMoneyValueFatura(total) }}</v-chip></v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from '../../../plugins/axios';
import utilitarios from '../../../plugins/utilitarios';
const ls = require('local-storage');
import Swal from 'sweetalert2'
import impressaoService from '../../../services/impressaoService';
export default {
  data: () => ({
    isLoading: false,
    dados: [],
    emolumentos:[],
    classes: utilitarios.ArrayCLasses(),
    isLodingPDF: false,
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    menu2: null,
    editedItem:{
      emolumento:'',
      classe:''
    },
    util: utilitarios,
    headers: [
      { text: 'Nº de Ordem.', value: 'ordem' },
      { text: 'Estudante', value: 'cliente' },
      { text: 'Quant.', value: 'qtd' },
      { text: 'Preço Unitário', value: 'precoUnitario' },
      { text: 'I.V.A', value: 'iva' },
      { text: 'Total', value: 'subtotal' }
    ],
    searchInDb: '',
    dialog: false,
    overlay: false,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    config: null,
    baseUrl: '',
    templateFull: null
  }),

  computed: {
    licencaExpirada() {
      return ls.get('licencaExpirada')
    },
    total() {
      let total_ = 0
      this.dados.forEach(element => {
        total_ += element.subtotal
      });
      return total_
    }
  },

  created() {
    this.InitializeEmolumentos();
    this.config = ls.get('configuracaoinstituicao');
    this.getUrlImpressao();
    this.getTemplateRelatorio();
  },

  methods: {

    async InitializeEmolumentos() {
      try {
        this.overlay = true;
        this.emolumentos = await axios.get('getEmolumentosFindAll').then((res) => res.data);
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar os emolumentos.');
      } finally {
        this.overlay = false;
      }
    },


    async getTemplateRelatorio() {
      try {
        this.overlay = true;
        this.templateFull = await axios.get('/obterRelatorioByDescricao/epc').then((res) => res.data[0]);
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante o carregamento do pdf do relatório!');
      } finally {
        this.overlay = false;
      }
    },

    async getUrlImpressao() {
      this.overlay = true;
      try {
        this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url);
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante o carregamento do endereço do servidor de impressão!');
      } finally {
        this.overlay = false;
      }
    },

    
    async getVendas() {
      if (this.licencaExpirada) {
        Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info');
      }  else {
        try {
          this.isLodingPDF = true;
          this.overlay = true;
          let params = {
             item: this.editedItem
          }
          this.dados = await axios.post('VendasFindAllbyEmolumentosAndClasse', params).then((res) => res.data)
        } catch (error) {
          utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar os seus dados.');
        } finally {
          this.isLodingPDF = false;
          this.overlay = false;
          if (this.dados.length === 0) {
            utilitarios.showAlertMessage('warning', 'Informação não encontrada.');
          }
        }
      }
    },

    // Método responsavel por criar um HTML com os dados da coleção this.dados[]
    async gerarHTML() {
      try {
        this.$store.state.loading_pdf = true;
        let template = this.templateFull.documento;
        let relatorioDados = '';
        let c = 1;

        this.dados.forEach(element => {
          let interacao1 = this.templateFull.documentoiteracao1;
          interacao1 = interacao1.replace('{{index}}', c++);
          interacao1 = interacao1.replace('{{nome}}', element.cliente);
          interacao1 = interacao1.replace('{{qtd}}', element.qtd);
          interacao1 = interacao1.replace('{{precoUnitario}}', this.util.IntegerToMoneyValueFatura(element.precoUnitario));
          interacao1 = interacao1.replace('{{iva}}', this.util.IntegerToMoneyValueFatura(element.iva));
          interacao1 = interacao1.replace('{{total}}', this.util.IntegerToMoneyValueFatura(element.subtotal));
          relatorioDados += interacao1;
        })

        let dadoss = {
          '{{logoInstituicao}}': this.config.logo,
          '{{nomeInstituicao}}': this.config.nome,
          '{{emolumento}}': this.editedItem.emolumento.descricao,
          '{{classe}}': this.editedItem.classe.descricao,
          '{{author}}': ls.get('nomeUsuario'),
          '{{dataEmissao}}': this.data_hora(),
          '{{totalGeral}}': this.util.IntegerToMoneyValueFatura(this.total),
          '{{dados}}': relatorioDados
        }

        const expressaoRegular = new RegExp(Object.keys(dadoss).join("|"), "g");
        template = template.replace(expressaoRegular, (match) => dadoss[match]);

        let options = {
          'format': 'A4',
          'border': {'right': '9mm', 'left': '9mm'},
          'header': {'height': '10mm'},
          'footer': {'height': '1mm'}
        }

        impressaoService.htmlToPdf(template, options);
      } catch (error) {
        this.$store.state.loading_pdf = false;
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante a impressão do documento.');
      }
    },

    // Método responsavél por guardar a data atual
    data_hora() {
      let data = new Date()
      return data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear()) + ' ' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
    }
  }
}
</script>
<style scoped></style>
